import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldAlert } from 'lucide-react';

export function UnauthorizedPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex min-h-96 max-w-md flex-col items-center justify-center gap-4 text-center">
      <span className="grid size-14 place-items-center rounded-full bg-amber-50 text-amber-600">
        <ShieldAlert className="size-7" aria-hidden />
      </span>
      <h1 className="text-ink text-xl font-semibold">{t('errors.unauthorizedTitle')}</h1>
      <p className="text-muted text-sm">{t('errors.unauthorizedBody')}</p>
      <Link
        to="/"
        className="bg-brand-600 hover:bg-brand-700 mt-2 inline-flex h-10 items-center rounded-lg px-4 text-sm font-medium text-white"
      >
        {t('errors.backToDashboard')}
      </Link>
    </div>
  );
}
